<template>
	<div class="popular-list-container">
		<div class="popular-list-toolbar">
			<b-form-datepicker
				id="datepicker"
				size="sm"
				:date-disabled-fn="dateDisabled"
				@context="onDatePicked"
				v-model="date1"
				class="mb-1"
				today-button
				close-button
				locale="zh"
			></b-form-datepicker>
		</div>
		<div class="popular-list-scroll">
			<div v-if="stocks.length">
				<div v-bind:key="data.index" v-for="(data) in stocks">
					<b-list-group>
						<div class="mb-1">
							<StockTextPopularItem @p_show_kline="p_show_kline"
							:rank="data.rank"  :rank_diff="data.rank_diff" :stock_name="data.symbol_name" :stock_code="data.symbol_code" :pct="data.last_pct"></StockTextPopularItem>
						</div>
					</b-list-group>
				</div>
			</div>
			<div v-else class="popular-empty-state">
				<h5>无数据，换一天试试 😢</h5>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"

	import StockTextPopularItem from 'components/stock/StockTextPopularItem.vue'

	export default {
		data() {
			const now = new Date();
			const today = now.getFullYear() + '-' + this.mendZero((now.getMonth()) + 1) + '-' + this.mendZero(now.getDate());
			return {
				date1: today,
				stocks: []
			};
		},
		components: {
			StockTextPopularItem,
			// Navbar
		},
		mounted() {
			this.refresh_popular();
		},
		methods: {
			mendZero(num) {
				return (num = num < 10 ? '0' + num : num)
			},
			onDatePicked(){
				// console.log(ctx.selectedYMD);
				this.refresh_popular();
			},
			dateDisabled(ymd, date) {
				const weekday = date.getDay();
				const time = date.getTime()
				
				const now = new Date();
				const now_time = now.getTime();
				// 周六日不能选
				if(weekday === 0 || weekday === 6){
					return true;
				}
				//今天之后不能选
				if(time>=now_time){
					return true;
				}
				return false
			},
			refresh_popular(){
				request_zzquant({
						// url: 'stock/d/popular/' + this.date1
						url:'/open/sentiment/media/ths2/top?date1='+this.date1+'&top_n=100'
					})
					.then(res1 => {
						// console.log(res1['data']['data']);
						this.stocks = res1['data']['data'];
					})
					.catch(err => {
						console.log(err);
					});
			},
			p_show_kline(symbol_code){
				// console.log("p click "+symbol_code);
				this.$emit('p_show_kline',symbol_code)
			}
		}
	};
</script>

<style scoped>
.popular-list-container {
	display: flex;
	flex-direction: column;
	height: calc(100vh - 165px);
	min-height: 420px;
}

.popular-list-toolbar {
	position: sticky;
	top: 0;
	z-index: 2;
	background: var(--bg-main, transparent);
	padding-bottom: 4px;
}

.popular-list-scroll {
	flex: 1;
	overflow-y: auto;
	padding-right: 4px;
}

.popular-list-scroll::-webkit-scrollbar {
	width: 6px;
}

.popular-list-scroll::-webkit-scrollbar-thumb {
	background: rgba(128, 128, 128, 0.45);
	border-radius: 999px;
}

.popular-empty-state {
	min-height: 180px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
}

@media (max-width: 767.98px) {
	.popular-list-container {
		height: auto;
		min-height: 0;
	}

	.popular-list-toolbar {
		position: static;
	}

	.popular-list-scroll {
		overflow-y: visible;
		padding-right: 0;
	}
}
</style>
